const timezones = [{
  offset: '660',
  label: '(GMT-11:00)',
  tzCode: 'Pacific/Niue',
},
{
  offset: '600',
  label: '(GMT-10:00)',
  tzCode: 'Pacific/Tahiti',
},
{
  offset: '570',
  label: '(GMT-09:30)',
  tzCode: 'Pacific/Marquesas',
},
{
  offset: '540',
  label: '(GMT-09:00)',
  tzCode: 'America/Anchorage',
},
{
  offset: '480',
  label: '(GMT-08:00) Pacific Time',
  tzCode: 'America/Los_Angeles',
},
{
  offset: '420',
  label: '(GMT-07:00) Mountain Time',
  tzCode: 'America/Denver',
},
{
  offset: '360',
  label: '(GMT-06:00) Central Time',
  tzCode: 'America/Chicago',
},
{
  offset: '300',
  label: '(GMT-05:00) Eastern Time',
  tzCode: 'America/New_York',
},
{
  offset: '240',
  label: '(GMT-04:00) Atlantic Time',
  tzCode: 'America/Halifax',
},
{
  offset: '210',
  label: '(GMT-03:30)',
  tzCode: 'America/St_Johns',
},
{
  offset: '180',
  label: '(GMT-03:00)',
  tzCode: 'America/Araguaina',
},
{
  offset: '120',
  label: '(GMT-02:00)',
  tzCode: 'America/Noronha',
},
{
  offset: '60',
  label: '(GMT-01:00)',
  tzCode: 'Atlantic/Azores',
},
{
  offset: '0',
  label: '(GMT+00:00) GMT',
  tzCode: 'Africa/Abidjan',
},
{
  offset: '-60',
  label: '(GMT+01:00)',
  tzCode: 'Africa/Algiers',
},
{
  offset: '-120',
  label: '(GMT+02:00)',
  tzCode: 'Asia/Amman',
},
{
  offset: '-180',
  label: '(GMT+03:00)',
  tzCode: 'Asia/Baghdad',
},
{
  offset: '-210',
  label: '(GMT+03:30)',
  tzCode: 'Asia/Tehran',
},
{
  offset: '-240',
  label: '(GMT+04:00)',
  tzCode: 'Asia/Baku',
},
{
  offset: '-270',
  label: '(GMT+04:30)',
  tzCode: 'Asia/Kabul',
},
{
  offset: '-300',
  label: '(GMT+05:00)',
  tzCode: 'Asia/Aqtau',
},
{
  offset: '-330',
  label: '(GMT+05:30)',
  tzCode: 'Asia/Colombo',
},
{
  offset: '-345',
  label: '(GMT+05:45)',
  tzCode: 'Asia/Kathmandu',
},
{
  offset: '-360',
  label: '(GMT+06:00)',
  tzCode: 'Asia/Almaty',
},
{
  offset: '-390',
  label: '(GMT+06:30)',
  tzCode: 'Indian/Cocos',
},
{
  offset: '-420',
  label: '(GMT+07:00)',
  tzCode: 'Asia/Bangkok',
},
{
  offset: '-480',
  label: '(GMT+08:00)',
  tzCode: 'Asia/Brunei',
},
{
  offset: '-510',
  label: '(GMT+08:30)',
  tzCode: 'Asia/Pyongyang',
},
{
  offset: '-540',
  label: '(GMT+09:00)',
  tzCode: 'Asia/Dili',
},
{
  offset: '-570',
  label: '(GMT+09:30)',
  tzCode: 'Australia/Darwin',
},
{
  offset: '-600',
  label: '(GMT+10:00)',
  tzCode: 'Pacific/Guam',
},
{
  offset: '-630',
  label: '(GMT+10:30)',
  tzCode: 'Australia/Adelaide',
},
{
  offset: '-660',
  label: '(GMT+11:00)',
  tzCode: 'Antarctica/Casey',
},
{
  offset: '-720',
  label: '(GMT+12:00)',
  tzCode: 'Pacific/Funafuti',
},
{
  offset: '-780',
  label: '(GMT+13:00)',
  tzCode: 'Pacific/Auckland',
},
{
  offset: '-840',
  label: '(GMT+14:00)',
  tzCode: 'Pacific/Apia',
},
];
/* eslint-disable */
function getTimestamp(date, tz) {
  const localTimezone = (new Date().getTimezoneOffset());
  const relativeTimezoneOffset = (tz - localTimezone);
  const ndate = new Date();
  ndate.setTime(date.getTime() + relativeTimezoneOffset * 60 * 1000);
  return ndate.toISOString().replace('T', ' ').split('.')[0];
}

function formatHours(tzmins) {
  let direction = '-';
  if (tzmins < 0) {
    direction = '+';
    tzmins *= -1;
  }
  let mins = (tzmins % 60);
  let hours = (tzmins - mins) / 60;
  if (mins < 10) {
    mins = `0${mins}`;
  }
  if (hours < 10) {
    hours = `0${hours}`;
  }
  return `${direction + hours}:${mins}`;
}

export default {
  timezones,
  formatHours,
  getTimestamp,
};
